import { render } from "./MobilityFlaggingMonitorTable.vue?vue&type=template&id=252e87b4&scoped=true&ts=true"
import script from "./MobilityFlaggingMonitorTable.vue?vue&type=script&lang=ts"
export * from "./MobilityFlaggingMonitorTable.vue?vue&type=script&lang=ts"

import "./MobilityFlaggingMonitorTable.vue?vue&type=style&index=0&id=252e87b4&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252e87b4"]])

export default __exports__